<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [leftButton]="{
    type: BUTTON_TYPES.CANCEL_BUTTON,
  }"
  [rightButton]="{
    text: CONFIRM_BUTTON,
    disable: false,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitExit)="onClose(BUTTON_CLICK.REJECT)"
  (emitLeftClick)="onClose(BUTTON_CLICK.REJECT)"
  (emitRightClick)="onClose(BUTTON_CLICK.ACCEPT)"
>
  <div class="body">
    <ion-row>
      <ion-col size="12">
        <div>
          {{ CONSTS.BODY }}
        </div>
      </ion-col>
    </ion-row>

    <!-- Email ID -->
    <ion-row class="row">
      <ion-col size="12">
        <div>{{ CONSTS.EMAIL_ID }}: {{ data.emailId }}</div>
      </ion-col>
    </ion-row>
  </div>
</app-modal-frame>
